import { render, staticRenderFns } from "./menu-dialog.vue?vue&type=template&id=3df90372&"
import script from "./menu-dialog.vue?vue&type=script&lang=js&"
export * from "./menu-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports